// Blackbaud Raiser's Edge NXT deep-link helpers.
// The environment id (envid) identifies the NXT environment and differs per
// deployment environment. Configure it via VITE_NXT_ENV_ID; the fallback is the
// Help Hope Live production environment.
const NXT_ENV_ID = import.meta.env.VITE_NXT_ENV_ID || 'p-NCVgpydXXUiS7dbMfV-CHQ';

const NXT_HOST = 'https://host.nxt.blackbaud.com';

export const nxtFundsListUrl = (): string => `${NXT_HOST}/cfa/funds?envid=${NXT_ENV_ID}`;

export const nxtFundUrl = (fundId: string): string =>
    `${NXT_HOST}/cfa/funds/${encodeURIComponent(fundId)}?envid=${NXT_ENV_ID}`;

export const nxtGiftUrl = (giftId: string): string =>
    `${NXT_HOST}/gift/page/${encodeURIComponent(giftId)}?svcid=renxt&envid=${NXT_ENV_ID}`;
